module.exports = __webpack_public_path__ + "static/height-52d6cd7ee205df6928a59e7df11ca939.svg";